export function loadChargebeeScript() {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = 'https://js.chargebee.com/v2/chargebee.js'
        script.type = 'text/javascript';
    
        script.onload = () => {
            resolve(true)
        }

        document.body.appendChild(script)
    })
}